var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 557 c-8 -8 -61 -34 -117 -58 -57 -24 -103 -47 -103 -52 0 -4 -4 -5 -10 -2 -5 3 -10 1 -10 -5 0 -6 -4 -8 -10 -5 -15 9 -12 -11 3 -23 10 -9 41 2 126 43 122 60 127 61 134 43 8 -20 28 13 25 41 -4 29 -18 36 -38 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 408 c5 -8 1 -9 -12 -4 -10 4 -15 3 -10 -1 4 -4 -32 -27 -81 -50 l-88 -42 50 6 c28 3 58 10 68 15 10 5 26 11 36 13 9 2 34 15 55 29 29 20 34 27 22 31 -9 3 -23 7 -32 10 -9 3 -12 1 -8 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 330 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 303 c-73 -4 -78 -5 -78 -26 0 -41 14 -50 69 -45 34 3 57 1 69 -8 23 -18 151 -19 158 -1 2 7 -2 30 -11 50 -17 42 2 39 -207 30z m142 -23 c0 -20 -15 -25 -44 -14 -28 11 -18 34 14 34 23 0 30 -4 30 -20z m57 -18 c11 -28 11 -33 -2 -38 -23 -9 -45 15 -45 48 0 40 29 34 47 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 291 c-3 -6 -1 -20 5 -31 6 -11 8 -25 5 -30 -3 -6 -1 -10 4 -10 6 0 12 11 13 25 0 14 1 30 2 37 1 15 -20 22 -29 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 192 c-4 -3 -6 -20 -6 -38 0 -23 5 -33 20 -37 12 -3 20 0 20 7 0 19 34 46 57 46 20 0 53 -28 53 -46 0 -5 36 -9 80 -9 51 0 80 4 80 11 0 18 35 44 58 44 14 0 30 -12 43 -33 l20 -32 -7 40 c-4 22 -8 43 -10 46 -4 8 -401 9 -408 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 144 c-9 -8 -16 -22 -16 -29 0 -18 27 -45 45 -45 18 0 45 27 45 45 0 18 -27 45 -45 45 -7 0 -21 -7 -29 -16z m52 -27 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 149 c-34 -19 -16 -79 23 -79 21 0 49 26 49 45 0 17 -27 45 -43 45 -7 0 -20 -5 -29 -11z m50 -32 c4 -20 -25 -34 -40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle14);
export default __webpack_public_path__ + "static/media/vehicle14.f257b316bf99fb1ea8c5282c93718851.svg";
export { ForwardRef as ReactComponent };